import Loadable from '../../components/loadable';

const GymDashletLibrary = Loadable({
  loader: () => import('../../pages/account_profile/gym_dashlet_library'),
});

angular.module('gym').value('GymDashletLibrary', GymDashletLibrary);
